import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ApiService from "../../network/ApiService";
import engToNepNumber from "../../helpers/EngToNepNumber";
import { Link } from "react-router-dom";

function DownloadDetails({ detailId, setAboutUsId }) {
  const { fetchDownloads } = ApiService();
  const { organizationId } = useSelector((state) => state.organization);
  const [downloadDocuments, setDownloadDocuments] = useState([]);
  const languageStatus = sessionStorage.getItem("language");

  useEffect(() => {
    if (organizationId) {
      fetchDownloads()
        .then((response) => setDownloadDocuments(response.data.messageWithImg))
        .catch((err) => console.log(err.message));
    }
  }, [organizationId]);

  const currentDetail = downloadDocuments.find((d) => d.aboutUsId === detailId);

  if (!currentDetail) {
    return (
      <div className="uk-section uk-section-default section-contact">
        <div className="uk-container">
          <p>{languageStatus === "en" ? "Loading..." : "लोड हुँदैछ..."}</p>
        </div>
      </div>
    );
  }

  const documents = currentDetail.documentWithNameList || [];

  return (
    <div className="uk-section uk-section-default section-contact">
      <div className="uk-container">
        <h2 className="uk-h2 uk-text-center uk-margin-large uk-flex uk-flex-between">
          <span className="underline-secondary">
            {languageStatus === "en"
              ? `${currentDetail.header ?? ""} - Download`
              : `${currentDetail.headerNp ?? ""} - डाउनलोड`}
          </span>
          <span onClick={() => setAboutUsId(null)} style={{ cursor: "pointer" }}>
            <img
              src="assets/images/svgs/arrow-left.svg"
              width="24"
              height="24"
              alt="Back"
            />
          </span>
        </h2>

        <table className="uk-table uk-table-striped">
          <thead>
            <tr>
              <th>{languageStatus === "en" ? "S.No" : "क्रम संख्या"}</th>
              <th>{languageStatus === "en" ? "Document Name" : "कागजातको नाम"}</th>
              <th>{languageStatus === "en" ? "Download" : "डाउनलोड"}</th>
            </tr>
          </thead>
          <tbody>
            {documents.length > 0 ? (
              documents.map((doc, index) => (
                <tr key={index}>
                  <th>{languageStatus === "en" ? index + 1 : engToNepNumber(index + 1)}</th>
                  <td>
                    {languageStatus === "en"
                      ? doc.docName ?? doc.docNameNp ?? "N/A"
                      : doc.docNameNp ?? doc.docName ?? "नाम भेटियन"}
                  </td>
                  <td>
                    <a href={doc.docUrl} target="_blank" download>
                      <img
                        src="assets/images/svgs/download.svg"
                        width="24"
                        height="24"
                        alt="Download"
                      />
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} style={{ fontSize: "20px", fontStyle: "italic" }}>
                  {languageStatus === "en"
                    ? "No File Available for Download"
                    : "डाउनलोड फाइल भेटियन..."}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DownloadDetails;
